import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import {Link} from 'react-scroll';
import Typical  from 'react-typical';


const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-2xl sm:text-5xl font-bold text-[#F5F51E]'>Hi, my name is</p>
        <h1 className='text-4xl sm:text-6xl font-bold text-[#ccd6f6]'>
          Abhiman Pratap Singh
        </h1>
        <h2 className='text-4xl sm:text-7xl font-bold text-[orange]'>
         {""}
          <Typical
          loop={Infinity}
          steps={["I'm a Full Stack Developer💻",
          3000,
          "Enthusiastic Dev😄",
          3000,
          "MERN Stack Dev🚀",
          3000,
          "Cross Platform Dev👨‍💻",
          3000,
          "React Native Dev🔥",
          3000,
          ]}/>
        </h2>
        <p className='transition ease-in-out delay-300 hover:-translate-y-1 hover:scale-110 hover: duration-300 text-[#8892b0] py-4 max-w-[700px]'>
          I’m a full-stack developer specializing in building (and occasionally
          designing) exceptional digital experiences. Currently, I’m focused on
          building responsive full-stack web applications.Developer with excellent problem -solving skills, 
          ability to perform well in a team and Passionate about coding .
        </p>
        <div>
       <button className=' text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
           View Work
            <span className=' group-hover:rotate-90  duration-300'>
              <HiArrowNarrowRight className='ml-3' />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
